import { render, staticRenderFns } from "./global-filters.vue?vue&type=template&id=a440024c&"
import script from "./global-filters.vue?vue&type=script&lang=js&"
export * from "./global-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports